import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-success text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }),
    /*#__PURE__*/_createTextVNode(" Support successfully submitted!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "We'll get back to you as soon as we can.")
], -1)
const _hoisted_4 = { class: "text-center mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Back to home ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-white mb-4" }, "Contact Support", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center" }, "Let us know what support you need and we'll get back at you as soon as we can.", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Social Security Number", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Email", -1)
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Date of Birth", -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label text-white" }, "Description", -1)
const _hoisted_18 = { class: "text-center mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("  Submit ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "Public/Login",
              class: "btn btn-lg btn-dark"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.ssn = $event)),
              placeholder: "###-##-####"
            }, null, 512), [
              [_vModelText, _ctx.ssn],
              [_directive_maska, '###-##-####']
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dob = $event))
            }, null, 512), [
              [_vModelText, _ctx.dob]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "10",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.description = $event))
            }, null, 512), [
              [_vModelText, _ctx.description]
            ])
          ]),
          _createElementVNode("p", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-lg btn-success",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.actions.submitSupport && _ctx.actions.submitSupport(...args)))
            }, _hoisted_21),
            _hoisted_22,
            _createVNode(_component_router_link, {
              to: "Public/Login",
              class: "btn btn-lg btn-dark"
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}